import React, { Fragment } from 'react';

import API from '../../../../utils/API';

import FieldModal from '../../../../components/modals/fieldModal';

import InputField from '../../../../components/inputs/inputField';
import { withRouter } from 'react-router-dom';

class DuplicateTemplateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.template.name ? this.props.template.name.concat(' Copy') : '',
            submitting: false,
            requiredFields: { name: false }
        };
    }


    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    duplicateTemplate = async () => {
        this.setState({ submitting: true });
        const { name } = this.state;
        const { eventId, orgId, email, template, update, toggle, keyedMetadata } = this.props;
        const requiredFields = this.state.requiredFields;
        let valid = true;
        if (!name) {
            requiredFields.name = true;
            valid = false;
        }
        if (valid) {
            await API()
                .post(`Organizations/${orgId}/events/${eventId}/template`, { name: name, templateId: template._id })
                .then((res) => {
                    const templateObj = res.data;

                    if (res.data) {
                        window.open(`/${orgId}/events/${eventId}/emails/templates/${templateObj._id}`, '_self');
                    } else {
                    }
                });
        } else {
            this.setState({ submitting: false, requiredFields: requiredFields });
        }
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, name, requiredFields } = this.state;

        return (
            <div>

                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Duplicate Campaign"}
                    bodyHeaderText={'Enter a new name for your campaign.'}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Name"
                                    value={name}
                                    required={true}
                                    errorTrigger={requiredFields.name}
                                    onChange={this.handleNameChange}
                                />
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Save' : 'Saving...'}
                    actionButton={() => this.duplicateTemplate()}
                    actionButtonDisabled={submitting}


                ></FieldModal>

            </div>

        );
    }
}

export default withRouter(DuplicateTemplateModal);
